import React, { memo, useCallback } from 'react';
/** REDUX */
import { useDispatch, useSelector } from 'react-redux';
import {
  setActiveTagAction,
  setGlobalLoaderAction,
  switchChannelAction,
} from '../../../redux/actions/collaboration';
/** COMPONENTS */
import CollaborationUser from '../CollaborationUser';
/** UTILS */
import Syndicate from '../../../pages/Auth/utils/Syndicate';
/** CUSTOM UI COMPONENTS */
import * as CollaborationUserListUI from './CollaborationUserListUI';

export default memo(function CollaborationUserList() {
  const dispatch = useDispatch();
  const { logo } = Syndicate.getData();

  const mainChannelId = useSelector(
    (state: any) => state.collaboration.mainChannelId,
  );
  const currentChannelId = useSelector(
    (state: any) => state.collaboration.currentChannelId,
  );
  const activeTag = useSelector((state: any) => state.collaboration.activeTag);

  /* Switch current active channel and clear the active tag if it's enabled */
  const switchChannel = useCallback(
    (channelId: string) => {
      if (currentChannelId === channelId && !activeTag) {
        return;
      }
      if (currentChannelId === channelId && activeTag) {
        dispatch(setActiveTagAction(''));
        dispatch(setGlobalLoaderAction(true));
        return;
      }

      dispatch(switchChannelAction(channelId));
    },
    [dispatch, activeTag, currentChannelId],
  );

  return (
    <CollaborationUserListUI.Container>
      <CollaborationUser
        isMainAvatar
        channelId={mainChannelId}
        isSelected={activeTag === '' && currentChannelId === mainChannelId}
        onClickCallback={switchChannel}
        userImageSrc={logo}
      />
    </CollaborationUserListUI.Container>
  );
});
